import { useConfig } from "app/contexts/ConfigContext";

/** Whether the Datadog integration is available (the "datadog" dev flag). */
export function useIsDatadogAvailable() {
  const config = useConfig();

  return Boolean(config?.dev_flags?.includes("datadog"));
}
